import { Static, Type } from '@sinclair/typebox'
import { BaseModelSchema, Nullable } from '../common/base-model'

export const AccountTenantName = ' account'
export const TenantPrefix = 'tenant_'
export const TenantBaseSchema = 'public'
export const TenantIdStoreKey = 'tenantId'

export enum TenantStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    MIGRATING = 'MIGRATING',
}

export const Tenant = Type.Object({
    ...BaseModelSchema,
    name: Type.String(),
    client_id: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    status: Type.Enum(TenantStatus),
    isInternalKizeo: Type.Boolean(),
    deleted: Nullable(Type.String()),
})

export type Tenant = Static<typeof Tenant>
